/* SEYUN foundation offers: free gift lines follow the number of bottles in the cart, on every page.
   A pack = the "1 Bottle" variant x quantity. Rule: 1 gift (of each kind) per pair of bottles of the same PDP
   (>=2 -> 1, >=4 -> 2 ...), gift removed below 2 bottles, added back when a pair is reached.
   Only gift lines carrying _free_gift = the offer tag are managed (other offers' Mystery Gift lines are never touched).
   Legacy "2 Bottles" variants still count as 2 bottles until they are deleted. Test override: window.SEYUN_FD_SYNC_CONFIG. */
(() => {
  if (window.__seyunFdSync) return;
  const cfg = Object.assign({
    gifts: [
      { id: '67786343219507', tag: 'foundation-offer', bottles: { '67786349576499': 1, '67786349609267': 2, '67786349838643': 1, '67786349871411': 2 } },
      { id: '67786343219507', tag: 'foundation-offer-b', bottles: { '67789254328627': 1, '67789254361395': 2 } },
      { id: '67789944324403', tag: 'foundation-offer-b', bottles: { '67789254328627': 1, '67789254361395': 2 } }
    ]
  }, window.SEYUN_FD_SYNC_CONFIG || {});
  window.__seyunFdSync = true;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const H = { 'Content-Type': 'application/json', Accept: 'application/json' };
  let busy = false, timer, retries = 0;

  const css = document.createElement('style');
  css.id = 'sfd-gift-lock';
  const sel = '.moonbundle-cart-item[data-item-key^="67786343219507:"]';
  css.textContent = sel + ' .moonbundle-cart-item-quantity-container,' + sel + ' .moonbundle-cart-item-remove-container{display:none!important}';
  document.head.appendChild(css);

  async function readCart() {
    for (let i = 0; i < 4; i++) {
      try {
        const r = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (r.ok) return await r.json();
      } catch (e) {}
      await new Promise(r => setTimeout(r, 1200));
    }
    return null;
  }
  async function post(path, body) {
    const r = await fetch(root + path, { method: 'POST', headers: H, body: JSON.stringify(body) });
    if (!r.ok) throw new Error('cart ' + r.status);
    return r.json();
  }
  async function reconcile() {
    if (busy) return;
    busy = true;
    try {
      const cart = await readCart();
      if (!cart) { if (retries++ < 3) schedule(3000); return; }
      retries = 0;
      let changed = false;
      for (const gd of cfg.gifts) {
        const bottles = cart.items.reduce((s, i) => s + (gd.bottles[String(i.variant_id)] || 0) * i.quantity, 0);
        const want = Math.floor(bottles / 2);
        const lines = cart.items.filter(i => String(i.variant_id) === String(gd.id) && i.properties && i.properties._free_gift === gd.tag);
        const have = lines.reduce((s, i) => s + i.quantity, 0);
        if (have === want) continue;
        if (!lines.length) {
          await post('cart/add.js', { items: [{ id: Number(gd.id), quantity: want, properties: { _free_gift: gd.tag } }] });
        } else {
          await post('cart/change.js', { id: lines[0].key, quantity: want });
          for (const g of lines.slice(1)) await post('cart/change.js', { id: g.key, quantity: 0 });
        }
        changed = true;
      }
      if (changed) window.dispatchEvent(new CustomEvent('moonbundle-cart-updated', { detail: { caller: 'seyun-fd-sync' } }));
    } catch (e) { /* silent: never block the shopper */ }
    finally { busy = false; }
  }
  const schedule = (ms) => { clearTimeout(timer); timer = setTimeout(reconcile, ms || 400); };

  const orig = window.fetch;
  window.fetch = function (input) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const p = orig.apply(this, arguments);
    if (!busy && /\/cart\/(change|update|add)(\.js)?(\?|$)/.test(url) && !/moonbundle_ignore/.test(url)) p.then(() => schedule(), () => {});
    return p;
  };
  window.addEventListener('moonbundle-cart-updated', e => { if (!(e.detail && /^seyun-fd/.test(e.detail.caller || ''))) schedule(); });

  /* The cookie "cart" exists only when a cart exists: skip the network call for shoppers without a cart. */
  if (/(?:^|;\s*)cart=/.test(document.cookie)) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => schedule(200)); else schedule(200);
  }
})();
